module.exports = require("@ng-select/ng-select");